"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionType = void 0;
/**
 * 权限类型
 */
var PermissionType;
(function (PermissionType) {
    PermissionType["PUBLIC"] = "public";
    PermissionType["RESTRICTED"] = "restricted";
    PermissionType["ILLEGAL"] = "illegal";
    PermissionType["USER"] = "user";
    PermissionType["GROUP"] = "group";
    PermissionType["SPACE"] = "space";
    PermissionType["BOT"] = "bot";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
